import { Inject, Injectable, Optional } from '@angular/core';
import { WINDOW_OBJ } from '../../shared-injection-tokens/shared-injection-tokens';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(
    @Optional() @Inject(WINDOW_OBJ) private windowObj: Window
  ) { }

  public generateBlob(text: string): Blob {
    return new Blob([text]);
  }

  public download(obj: any, name: string, options?: BlobPropertyBag): void {
    const blob = obj instanceof Blob ? obj : new Blob([obj], options);
    const link = document.createElement('a');
    link.href = (this.windowObj as any).URL.createObjectURL(blob);
    link.download = name;
    link.target = '_blank';
    link.click();
  }

  public downloadFromText(text: string, name: string): void {
    const blob = this.generateBlob(text);
    this.download(blob, name);
  }
}
